export let composeDiscardButton = "AgtUKb";
export default {composeDiscardButton};